import {MsalAuthProvider, LoginType} from 'react-aad-msal';

const tenantId = process.env.REACT_APP_TENANT_ID ?? "4b9f04c7-27a3-4ed9-84ba-e970f8f33dd0";
// Msal Configurations
const config = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID ?? "e45f48a5-b00e-4e9a-9ad2-cf8996716b58",
    authority: `https://login.microsoftonline.com/${tenantId}/`,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    tokenRenewalOffsetSeconds: 300000
  }
};

// Authentication Parameters
export const authenticationParameters = {
  prompt: "select_account",
  scopes: [
    "openid",
    "profile",
    "email",
    "User.Read",
    `api://${process.env.REACT_APP_CLIENT_ID ?? "e45f48a5-b00e-4e9a-9ad2-cf8996716b58"}/access_as_user`,
  ]
}

// Options
const options = {
  loginType: LoginType.Popup
  // tokenRefreshUri: window.location.origin + '/auth.html'
}

export const authProvider = new MsalAuthProvider(config, authenticationParameters, options)

export const baseAPIURL = `${process.env.REACT_APP_BASE_URL}v1/`;